import { graphql } from "react-relay";

export const UpsertAnthropicIntegrationMutation = graphql`
  mutation UpsertAnthropicIntegrationMutation(
    $input: UpsertAnthropicIntegrationInput!
  ) {
    upsertAnthropicIntegration(input: $input) {
      anthropicIntegration {
        configured
        id
        orgId
      }
      problems {
        __typename
        message
      }
    }
  }
`;
